import { UnreachableFunction } from 'ui/base/types';
import Messages from './weekdays_messages';

export enum Weekday {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday',
}

export const ORDERED_WEEKDAYS: readonly Weekday[] = [
  Weekday.MONDAY,
  Weekday.TUESDAY,
  Weekday.WEDNESDAY,
  Weekday.THURSDAY,
  Weekday.FRIDAY,
  Weekday.SATURDAY,
  Weekday.SUNDAY,
];

export function getFullWeekday(day: Weekday) {
  switch(day) {
    case Weekday.MONDAY:
      return Messages.mondayFull();
    case Weekday.TUESDAY:
      return Messages.tuesdayFull();
    case Weekday.WEDNESDAY:
      return Messages.wednesdayFull();
    case Weekday.THURSDAY:
      return Messages.thursdayFull();
    case Weekday.FRIDAY:
      return Messages.fridayFull();
    case Weekday.SATURDAY:
      return Messages.saturdayFull();
    case Weekday.SUNDAY:
      return Messages.sundayFull();
    default:
      return UnreachableFunction(day);
  }
}

export function getShortWeekday(day: Weekday) {
  switch(day) {
    case Weekday.MONDAY:
      return Messages.mondayShort();
    case Weekday.TUESDAY:
      return Messages.tuesdayShort();
    case Weekday.WEDNESDAY:
      return Messages.wednesdayShort();
    case Weekday.THURSDAY:
      return Messages.thursdayShort();
    case Weekday.FRIDAY:
      return Messages.fridayShort();
    case Weekday.SATURDAY:
      return Messages.saturdayShort();
    case Weekday.SUNDAY:
      return Messages.sundayShort();
    default:
      return UnreachableFunction(day);
  }
}

export function getMicroWeekday(day: Weekday) {
  switch(day) {
    case Weekday.MONDAY:
      return Messages.mondayMicro();
    case Weekday.TUESDAY:
      return Messages.tuesdayMicro();
    case Weekday.WEDNESDAY:
      return Messages.wednesdayMicro();
    case Weekday.THURSDAY:
      return Messages.thursdayMicro();
    case Weekday.FRIDAY:
      return Messages.fridayMicro();
    case Weekday.SATURDAY:
      return Messages.saturdayMicro();
    case Weekday.SUNDAY:
      return Messages.sundayMicro();
    default:
      return UnreachableFunction(day);
  }
}
